/**
 * FAQ functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class FAQ {
  /**
   * Constructs a new FAQ instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.question = this.element.queryAll('ul li')

    this.question.forEach(element => {
      const toggle = element.querySelector('header')
      toggle.addEventListener('click', e => {
        var index = this.question.indexOf(element)
        if (element.classList.contains('open')) {
          this.close(this.question)
          e.preventDefault()
        } else {
          e.preventDefault()
          this.close(this.question)
          this.open(element, index)
        }
      })
    })
  }

  /**
  * Closes expanded state.
  */
  close (question) {
    this.question.forEach(element => {
      element.classList.remove('open')
    })
  }

  /**
  * Opens expanded state.
  */
  open (element, index) {
    element.classList.add('open')
  }
}



// WEBPACK FOOTER //
// ./components/faq/index.js